import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";

// Pages
import HomePage from "./pages/HomePage";
import WhatIsCoherenceOS from "./pages/WhatIsCoherenceOS";
import TheCategory from "./pages/TheCategory";
import CoherenceMetrics from "./pages/CoherenceMetrics";
import ForInvestors from "./pages/ForInvestors";
import ForBuilders from "./pages/ForBuilders";
import ArticlesPage from "./pages/ArticlesPage";
import ArticlePage from "./pages/ArticlePage";

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/what-is-coherence-os" element={<WhatIsCoherenceOS />} />
          <Route path="/the-category" element={<TheCategory />} />
          <Route path="/coherence-metrics" element={<CoherenceMetrics />} />
          <Route path="/for-investors" element={<ForInvestors />} />
          <Route path="/for-builders" element={<ForBuilders />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/articles/:articleId" element={<ArticlePage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
